import { FC } from 'react';
import Head from 'next/head';
import Image from "next/legacy/image";
import Link from 'next/link';
import ListingArticleBox from 'components/Blog/ListingArticleBox';
import Breadcrumb from 'components/Breadcrumb/Breadcrumb';
import BlogBg from '../../public/images/BlogBg.jpg';
import notionDataService from 'services/notiondata.service';
import { BlogPost } from 'constants/notionDataPages';
import { getSeoMetaTags } from 'utils/common.utils';
import { SeoMetaTags } from 'constants/dataTypes';
import GlobalSeoMetaTags from 'components/GlobalSeoMetaTags/GlobalSeoMetaTags';

export interface BlogListPageProps {
  title: string;
  description: string;
  h1: string;
  posts: BlogPost[];
  seoMetaTags: SeoMetaTags;
}

const BREADCRUMB_DATA = [
  {
    id: 1,
    href: '',
    text: 'Dresden Vision'
  },
  {
    id: 2,
    href: '',
    text: 'Blog'
  }
];

const StoreLocationView: FC<BlogListPageProps> = ({
  title,
  description,
  posts,
  h1,
  seoMetaTags
}) => {
  return (
    <div>
      <Head>
        <title>{title}</title>
        <meta name="twitter:title" content={title} />
        <meta name="og:title" content={title} />
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta name="twitter:description" content={description} />
      </Head>
      <div className="relative h-[280px] w-full">
        <div className="absolute inset-0 z-10 flex h-full w-full items-center justify-center bg-black bg-opacity-20">
          <h1 className="p-4 text-center font-sans text-4xl font-bold text-white">
            {h1}
          </h1>
        </div>
        <Image
          objectPosition="center"
          objectFit="cover"
          src={BlogBg}
          layout="fill"
          quality={65}
          alt="Dresden Stores"
          priority
        />
      </div>
      <div className="mx-auto mt-[18px] max-w-[1400px] px-4">
        <div className="mb-[18px]">
          <Breadcrumb data={BREADCRUMB_DATA} />
        </div>
        <div className="grid grid-cols-1 gap-[60px]">
          {posts.map((post, index) => (
            (<Link
              prefetch={false}
              href={`/blog/${post.slug}`}
              key={post.slug}>

              <ListingArticleBox 
                preload={(index < 2)}
                reverse={!!(index % 2)} 
                post={post} 
                index={index}
              />

            </Link>) 
          ))}
        </div>
      </div> 
      <GlobalSeoMetaTags seoMetaTags={seoMetaTags} />
    </div>
  );
};

export const getStaticProps = async ({
  locale
}: {
  locale: string;
}) => {

  const posts = await notionDataService.getPageList('blog', locale);

  //const postsAllRegion = await blogService.getBlogPostList();
  //fetch json from https://wc-api-dev.dresden.io/api/blog

  //filter list by checking if region array contains locale or empty
  //const posts = postsAllRegion.filter((item) => item.region.includes(locale) || item.region.length === 0);

  const seoMetaTags = await getSeoMetaTags( '/blog', locale);

  
  return {
    props: {
      title:
        'Blog: Upclose with Dresden | Eye Care Blog & Glasses and Style Trends - Dresden',
      description:
        "If you're looking for glasses; Visit the Dresden Blog pages for eye health tips, latest glasses trends and interviews.",
      h1: 'Blog: Upclose with Dresden',
      posts,
      seoMetaTags
    }
  };
};

export default StoreLocationView;
